import React, { useState } from "react";

import { Button, Input } from "reactstrap";
import { Modal } from "react-bootstrap";
import Loading from "../../../loader/loader";
import { updateEidNumberService } from "../../../../service/user-detail-service";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../../../common/notification-message/notification";
import { useLocation } from "react-router-dom";

const UpdateEidNumber = ({
  show = false,
  onHide,
  oldEIDNumber,
  cardHolderId,
  getuserProfileDetailById,
}) => {
  const [newEIDValue, setNewEIDValue] = useState();
  const [errorMsg, setErrorMsg] = useState(false);
  const [buttonloading, setButtonloading] = useState(false);
  const { state } = useLocation();

  const saveEidNumber = () => {
    setButtonloading(true);
    let req = {};
    req.newEidNumber = newEIDValue;
    req.cardHolderId = cardHolderId;

    updateEidNumberService(req)
      .then(() => {
        setNewEIDValue("");
        setButtonloading(false);
        onHide();
        getuserProfileDetailById(state.id);
        openNotificationWithIcon(
          notificationStrings.success,
          "EID number updated successfully!"
        );
      })
      .catch((err) => {
        console.log(err);
        setButtonloading(false);
        onHide();
      });
  };

  const validatEidNumber = () => {
    const eidPattern = /^784[0-9]{12}$/;
    eidPattern.test(newEIDValue);

    if (eidPattern.test(newEIDValue)) {
      setErrorMsg(false);
      saveEidNumber();
    } else {
      setErrorMsg(true);
    }
  };

  return (
    <>
      <Modal
        onHide={onHide}
        show={show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="rak-beneficiary-modal"
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMsg ? (
            <>
              <div style={{ color: "red", fontSize: "10px" }}>
                1. 15 char length should be mandatory.
              </div>
              <div style={{ color: "red", fontSize: "10px" }}>
                2. The EID number should start from 784.
              </div>
            </>
          ) : (
            ""
          )}
          <div>
            <label className="form-control-label" htmlFor="example3cols2Input">
              Old EID Number
            </label>
            <Input
              id="example3cols2Input"
              placeholder="784xxxxxxxxxxxx"
              type="text"
              style={{ height: "27px" }}
              disabled
              value={oldEIDNumber}
            />
          </div>
        </Modal.Body>
        <Modal.Body>
          <div>
            <label className="form-control-label" htmlFor="example3cols2Input">
              Enter The New EID Number
            </label>
            <Input
              id="example3cols2Input"
              placeholder="784xxxxxxxxxxxx"
              type="text"
              style={{ height: "27px" }}
              onChange={(e) => setNewEIDValue(e.target.value)}
              value={newEIDValue}
              maxlength={15}
            />
          </div>
          <div style={{ marginTop: "14px" }}>
            <div
              style={{ color: "#575555", fontWeight: "800", fontSize: "12px" }}
            >
              Note:
            </div>
            <p style={{ color: "#575555", fontSize: "12px" }}>
              This will reset the KYC, and update the RMT profile to missing.
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              onHide();
              setNewEIDValue("");
              setErrorMsg(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            color="primary"
            onClick={() => {
              validatEidNumber();
            }}
            disabled={buttonloading}
          >
            {buttonloading ? (
              <Loading color="white" width="15px" height="15px" />
            ) : (
              "Save"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UpdateEidNumber;
